








import { Component, Vue } from "vue-property-decorator";
import { shareInfo } from "@/req/user";
@Component
export default class ComponentName extends Vue {
  public isIos = false;
  public list = [
    {
      id: 1,
      url: require("@/assets/img/1014Icon/share/vx.png"),
      text: "微信",
      toShare: "toShareWX",
    },
    {
      id: 2,
      url: require("@/assets/img/1014Icon/share/vxFriends.png"),
      text: "朋友圈",
      toShare: "toShareWXFriends",
    },
    {
      id: 3,
      url: require("@/assets/img/1014Icon/share/qq.png"),
      text: "QQ",
      toShare: "toShareQQ",
    },
  ];
  public metaArr = [
    {
      name: "title",
    },
    {
      name: "image",
    },
    {
      name: "description",
    },
  ];
  // {
  //   name: "url",
  // },
  public oMeta: any = null;

  public mounted() {
    if ((window as any).mb === "ios") {
      this.isIos = true;
    }
  }

  public async onShare(item) {
    const shareCode = "ACTIVITY_A1014_1";
    const fullUrl = window.location.href;
    const baseUrl = fullUrl.split("?")[0];
    const url =
      baseUrl +
      `?shareCode=${shareCode}` +
      "&is_nav_show=1&is_control_show=1" +
      "&rmToken=1";
    const res = await shareInfo({
      url,
    });
    if (res.code === 200) {
      await this.AddMeta({
        title: res.data.share_title,
        image: res.data.share_icon,
        description: res.data.share_content,
        // url: res.data.share_url,
      });
      this.urlShare(res.data, item);
    }
  }

  public urlShare(e, item) {
    const obj: any = {
      share_title: e.share_title,
      share_content: e.share_content,
      share_url: e.share_url,
      share_icon: e.share_icon,
    };
    obj[item.toShare] = "1";
    (window as any).sendToShareWX(obj);
  }

  public AddMeta(share) {
    this.metaArr.forEach((item) => {
      this.oMeta = document.createElement("meta");
      this.oMeta.setAttribute("content", share[item.name]); // ✅ 正确设置 content
      this.oMeta.setAttribute("property", "og:" + item.name); // ✅ 正确设置 property
      document.head.appendChild(this.oMeta); // 更简洁的写法
    });
  }
}
